import { Outlet } from 'react-router-dom';

import { Container } from '~/Components/Grid/Grid';
import Init from '~/Components/Init/Init';
import Menu from '~/Components/Menu/Menu';
import MenuSpacer from '~/Components/Menu/MenuSpacer';
import Spinner from '~/Components/Spinner/Spinner';

import Footer from './Components/Footer/Footer';
import { isInGame } from './utils';

const Root = () => {
  return (
    <>
      <MenuSpacer>
        <Container>
          <Init />
          <Outlet />
        </Container>
      </MenuSpacer>
      <Menu />
      <Spinner />
      {!isInGame && <Footer />}
    </>
  );
};

export default Root;
